export function InvoiceAddJobCardNotesCtrl ($state, $scope, $translate, gridAPI, templatedWording, workshopAPI, messages, invoice, Invoice) {

  $scope.invoice  = invoice;
  $scope.Invoice = new Invoice($scope.invoice);
  $scope.url = ''
  $scope.editable = $scope.invoice.invoice_status === 'O' ? true : false;
  $scope.loading = false;

  if ($scope.invoice.vehicle_id) {
    $scope.url = '/' + $scope.invoice.customer_id + '/' + $scope.invoice.vehicle_id + '/invoice/' + $scope.invoice.id;
  }
  else {
    $scope.url = '/' + $scope.invoice.customer_id + '/invoice/' + $scope.invoice.id;
  }


  $scope.save = function () {
    workshopAPI.patch('/invoice', $scope.invoice, 'invoice').then(function() {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.INVOICE'), 'success');
      $state.reload();
    }, function (err) {
      messages.error(err);
    })
  };

  $scope.addTemplates = function () {
    templatedWording.addTemplate('invoice').then(function (templates) {
      angular.forEach(templates, function (template, idx) {
        if ($scope.invoice.note) {
          $scope.invoice.note = $scope.invoice.note + '\n\n' + template.wording;
        }
        else {
          $scope.invoice.note = template.wording;
        }
      });
    });
  };

  $scope.addJobCardTemplates = function () {
    templatedWording.addTemplate('job_card').then(function (templates) {
      angular.forEach(templates, function (template, idx) {
        if ($scope.invoice.job_card_note) {
          $scope.invoice.job_card_note = $scope.invoice.job_card_note + '\n\n' + template.wording;
        }
        else {
          $scope.invoice.job_card_note = template.wording;
        }
      });
    });
  };
}